module.exports = __webpack_public_path__ + "media/images/lb/048-f687f1ca4e8a4162a5ff614d619c5e35.svg";